<script lang="ts">
	import { format } from 'svelte-i18n';
	import DashListHolder from '../components/Lists/Dashboards/DashListHolder.svelte';
	import { checkIsEventLogTab, sortByPosition } from '../components/Lists/list-helpers';
	import { capFirstChar } from '../helpers/utilities';
	import { isSubUnit } from 'src/helpers/user_helpers';
	import { isDevModalAvailable } from 'src/helpers/dev_tools';
	import { user_data } from 'src/stores/account/user';
	import { allEnergyWidgetsGalleryEnabled } from 'src/stores/features/dev/all-energy-widgets-gallery';
	import { allDeviceWidgetsGalleryEnabled } from 'src/stores/features/dev/all-device-widgets-gallery';
	import { mockLightsGalleryEnabled } from 'src/stores/features/dev/mock-lights-gallery';
	import { devices } from 'src/stores/lists/devices';
	import { scenes } from 'src/stores/lists/scenes';
	import { dashboards, extended_dashboards } from 'src/stores/features/dashboards';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import DashListHolderNew from 'src/components/Lists/Dashboards/DashListHolderNew.svelte';
	import EnergyMonitoringRoute from 'src/components/EnergyMonitoring/EnergyMonitoringRoute.svelte';
	import { isEnergyMonitoringDashboardId } from 'src/components/EnergyMonitoring/helpers/constants';
	import { getDashboardKind } from 'src/components/Dashboards/dashboard-kind';
	import CameraMonitoringRoute from 'src/components/Camera/CameraMonitoringRoute.svelte';
	import AllEnergyWidgetsDashboard from 'src/components/EnergyMonitoring/AllEnergyWidgetsDashboard.svelte';
	import { isAllEnergyWidgetsDashboardId } from 'src/components/EnergyMonitoring/v2/all-energy-widgets';
	import AllDeviceWidgetsDashboard from 'src/components/Dashboards/AllDeviceWidgetsDashboard.svelte';
	import { isAllDeviceWidgetsDashboardId } from 'src/components/Dashboards/all-device-widgets';
	import MockLightsGalleryDashboard from 'src/components/Dashboards/MockLightsGalleryDashboard.svelte';
	import { isMockLightsGalleryDashboardId } from 'src/components/Dashboards/mock-lights-gallery';
	import NotFound from './NotFound.svelte';

	export let params = { type: '', id: '-1' };

	$: list =
		$extended_dashboards?.[params.id]?.sort(sortByPosition).map((el) => {
			if (checkIsEventLogTab(el)) {
				el.text = capFirstChar($format(el.text));
			}

			return el;
		}) || [];

	// Shared-home widgets cache rights at mount; remount when refreshed rights change
	$: dashWidgetRightsKey = isSubUnit()
		? JSON.stringify([
				Object.values($devices).map((d) => d.rights),
				Object.values($scenes).map((s: any) => s._meta?.rights),
			])
		: 'owner';

	$: dashboardKind = getDashboardKind($dashboards[params.id]);
	$: isEnergyMonitoring = isEnergyMonitoringDashboardId(params.id) || dashboardKind === 'energy';
	$: isAllEnergyWidgets = isAllEnergyWidgetsDashboardId(params.id);
	$: canAccessAllEnergyWidgets =
		isDevModalAvailable($user_data?.email) && $allEnergyWidgetsGalleryEnabled;
	$: isAllDeviceWidgets = isAllDeviceWidgetsDashboardId(params.id);
	$: canAccessAllDeviceWidgets =
		isDevModalAvailable($user_data?.email) && $allDeviceWidgetsGalleryEnabled;
	$: isMockLightsGallery = isMockLightsGalleryDashboardId(params.id);
	$: canAccessMockLightsGallery = isDevModalAvailable($user_data?.email) && $mockLightsGalleryEnabled;
	$: isCameraDashboard = dashboardKind === 'camera';
</script>

{#if isAllEnergyWidgets && canAccessAllEnergyWidgets}
	<AllEnergyWidgetsDashboard />
{:else if isAllDeviceWidgets && canAccessAllDeviceWidgets}
	<AllDeviceWidgetsDashboard />
{:else if isMockLightsGallery && canAccessMockLightsGallery}
	<MockLightsGalleryDashboard />
{:else if isAllEnergyWidgets || isAllDeviceWidgets || isMockLightsGallery}
	<NotFound {params} />
{:else if isEnergyMonitoring}
	<EnergyMonitoringRoute id={params.id} />
{:else if isCameraDashboard}
	<CameraMonitoringRoute dashboardId={params.id} />
{:else}
	{#key dashWidgetRightsKey}
		{#if $showNewLayout}
			<DashListHolderNew id={params.id} />
		{:else}
			<DashListHolder id={params.id} {list} />
		{/if}
	{/key}
{/if}
